import React from "react";
import "./LiveCard.css"; // or create a new one like LiveCardSkeleton.css

const LiveCardSkeleton = () => {
  return (
    <div className="reel-card skeleton-card">
      {/* Header */}
      <div className="card-header">
        <div className="skeleton skeleton-circle profile-img" />
        <div className="skeleton-header-text">
          <div className="skeleton skeleton-line short" />
          <div className="skeleton skeleton-line tiny" />
        </div>
        <div className="skeleton skeleton-line dot" />
      </div>

      {/* Offer strip */}
      <div className="skeleton skeleton-line full" style={{ height: "30px", margin: "10px 0" }} />

      {/* Banner */}
      <div className="card-banner">
        <div className="skeleton skeleton-banner" />

        {/* <div className="event-details">
          <div className="skeleton skeleton-line medium" />
          <div className="skeleton skeleton-line short" />
          <div className="event-info">
            <div className="skeleton skeleton-line tiny" />
            <div className="skeleton skeleton-line tiny" />
          </div>
          <div className="skeleton skeleton-button" />
        </div> */}
      </div>

      {/* CTA Button */}
      {/* <div className="skeleton skeleton-line full" style={{ height: "35px", marginTop: "12px" }} /> */}

      {/* Icons */}
      <div className="card-icons">
        <div className="skeleton skeleton-icon" />
        <div className="card-icons-right">
          <div className="skeleton skeleton-icon" />
          <div className="skeleton skeleton-icon" />
        </div>
      </div>

      {/* Footer */}
      <div className="card-footer">
        <div className="skeleton skeleton-line medium" />
      </div>
    </div>
  );
};

export default LiveCardSkeleton;
